module.exports = __webpack_public_path__ + "media/sales_marketing_strategies/bidding_image-6bf31ad2.webp";